import { REPLAY_PASS_COST } from '../../../domain';
import { useAppStore } from '../../store/appStore';
import {
  createFailDeliveryScreenModel,
  type FailDeliveryScreenProps,
} from './FailDeliveryScreenModelScreen';
import { FailDeliveryScreenController } from './FailDeliveryScreenController';
import { FailDeliveryScreenView } from './FailDeliveryScreenView';
import { usePlaySoundOnMount } from '../../hooks/usePlaySoundOnMount';

export type { FailDeliveryScreenProps } from './FailDeliveryScreenModelScreen';

export function FailDeliveryScreen(props: FailDeliveryScreenProps) {
  usePlaySoundOnMount('delivery.fail');
  const passesBalance = useAppStore((s) => s.passesBalance);
  const canRestart =
    props.canRestart !== false && passesBalance >= REPLAY_PASS_COST;
  const model = createFailDeliveryScreenModel({ ...props, canRestart });
  const controller = new FailDeliveryScreenController(model);

  return <FailDeliveryScreenView model={model} controller={controller} />;
}
